import * as actionTypes from '../types/correctionSemiProducts';

const initialState = {
  semiProducts: [],
  correctionSemi: [],
  error: false,
  loading: false,
  okRequest: false,
  okRequestModal: false,
  loadingModal: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_SEMI_PRODUCT_BY_READY:
      return {
        ...state,
        okRequest: false,
        loading: true
      };
    case actionTypes.GET_SEMI_PRODUCT_BY_READY_SUCCESS:
      return {
        ...state,
        semiProducts: payload,
        okRequest: true,
        loading: false
      };
    case actionTypes.GET_SEMI_PRODUCT_BY_READY_FAIL:
      return {
        ...state,
        semiProducts: [],
        okRequest: false,
        loading: false
      };
    case actionTypes.GET_CORRECTION_SEMI:
      return {
        ...state,
        okRequest: false,
        loading: true
      };
    case actionTypes.GET_CORRECTION_SEMI_SUCCESS:
      return {
        ...state,
        correctionSemi: payload,
        okRequest: true,
        loading: false
      };
    case actionTypes.GET_CORRECTION_SEMI_FAIL:
      return {
        ...state,
        correctionSemi: [],
        okRequest: false,
        loading: false
      };
    case actionTypes.CLEAR_CORRECTION_SEMI_PRODUCTS:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;
